import { baseMenu, indonesiaMenu } from "./constants";

export const generateSidewidget = (country: "ID" | "MY" = "ID") => {
  if (country === "MY") {
    return baseMenu;
  }

  return [...baseMenu, ...indonesiaMenu];
};
